<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">The Death Of Nnanji</h1>
<h2 class="subtitle">The Seventh Sword Series: Book Four</h2>
<p class="author">Dave Duncan<br/><em>Editing by Robert Runté</em></p>
<p class="colophon"><img alt="Open Road logo" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section1.vue?0fc4d0a8